module.exports = __webpack_public_path__ + "static/img/health2.f7ffcf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/health2.png
// module id = mM/4
// module chunks = 0